import { Promos } from '@diamond/shared/types';
import {
  InfiniteData,
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';

import { getPromoDetail, getPromoList } from '../queries/promos';
import { useAuthStore, useShipToStore } from '../stores';

export const useGetPromos = (
  params: { pageSize?: number; type?: string } = {}
) => {
  const { pageSize = 24, type } = params;
  const session = useAuthStore();
  const { selectedShipToId } = useShipToStore();

  return useInfiniteQuery({
    queryKey: ['Promos', selectedShipToId, type],
    queryFn: async ({ pageParam = 1 }) => {
      return getPromoList(
        session.access_token,
        selectedShipToId,
        pageParam,
        pageSize,
        type
      );
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      if ((lastPage as any)?.pagination?.pages > pages.length) {
        return pages.length + 1;
      }
      return undefined;
    },
  });
};

export const useGetPromoDetail = (promoId: string) => {
  const session = useAuthStore();
  const { selectedShipToId } = useShipToStore();
  return useQuery({
    queryKey: ['Promos', promoId],
    queryFn: () =>
      getPromoDetail(session.access_token, selectedShipToId, promoId),
  });
};
